export default __webpack_public_path__ + "static/media/orevan-logo-white.24269545.png";